import React from 'react';
import { Box, IconButton, Tooltip, Fade, Badge } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { Bell } from 'phosphor-react';
import { useNotificationContext } from '../../providers/notification';
import { useSolicitacaoAcessoContext } from '../../providers/solicitacaoAcesso';

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.1); }
  100% { transform: scale(1); }
`;

export function NotificationBell() {
  const { unreadCount, isConnected, openPanel } = useNotificationContext();
  const { pendentesCount } = useSolicitacaoAcessoContext();
  const totalCount = unreadCount + pendentesCount;

  // Sino flutuante desativado — notificações agora ficam no header
  return null;

  return (
    <Fade in>
      <Box position="fixed" bottom="24px" right="24px" zIndex={51}>
        <Tooltip
          label={
            totalCount > 0 ? `Voce tem ${totalCount} notificacao(oes) nao lida(s)` : 'Notificacoes'
          }
          aria-label="Notificacoes"
          hasArrow
          placement="left"
        >
          <Box position="relative">
            <IconButton
              icon={<Bell size={24} weight="bold" />}
              aria-label="Notificacoes"
              colorScheme={totalCount > 0 ? 'red' : 'gray'}
              borderRadius="full"
              size="lg"
              onClick={openPanel}
              boxShadow="lg"
              animation={totalCount > 0 ? `${pulse} 2s ease-in-out infinite` : undefined}
              _hover={{
                transform: 'scale(1.05)',
                boxShadow: 'xl',
              }}
              transition="all 0.2s"
            />
            {totalCount > 0 && (
              <Badge
                position="absolute"
                top="-4px"
                right="-4px"
                colorScheme="red"
                borderRadius="full"
                minW="20px"
                h="20px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                border="2px solid white"
                fontSize="xs"
                fontWeight="bold"
              >
                {totalCount > 99 ? '99+' : totalCount}
              </Badge>
            )}
            {isConnected && (
              <Box
                position="absolute"
                bottom="-2px"
                right="-2px"
                w="10px"
                h="10px"
                bg="green.400"
                borderRadius="full"
                border="2px solid white"
              />
            )}
          </Box>
        </Tooltip>
      </Box>
    </Fade>
  );
}
